import { useContext, useEffect, useRef } from 'react';

import { RequestsContext } from '../../../contexts/requestsContext';
import useAsyncRequest from '../../../hooks/useAsyncRequest';
import { getValidCountryCode, getValidMissionSlug } from '../logic';

const useStats = (missionSlug, countryCode) => {
  const stats = useRef({});
  const [performRequest] = useContext(RequestsContext);
  const [fetchStats, fetchState] = useAsyncRequest(
    () => {
      const validMissionSlug = getValidMissionSlug(missionSlug);
      const validCountryCode = getValidCountryCode(countryCode);
      return performRequest({
        method: 'GET',
        url: `/stats/${validMissionSlug}/${validCountryCode}`,
      });
    },
    (newStatsContent) => {
      stats.current = newStatsContent;
    },
  );

  useEffect(() => {
    fetchStats();
  }, [missionSlug, countryCode]);

  return {
    stats: stats.current,
    statsState: fetchState,
  };
};

export default useStats;
